import React, { useEffect } from 'react'
import Nav from '../Components/Nav'
import Header from '../Components/Nenasa/Header'
import About from '../Components/Nenasa/About'
import Registration from '../Components/Nenasa/Registration'
import Footer from '../Components/Footer'

const Nenasa = () => {
    useEffect(() => {
        document.title = "ACQC - Anada Nenasa"
    });

    return (
        <div>
            <Nav />
            <Header />
            <About />
            <Registration />
            <Footer />
        </div>
    )
}

export default Nenasa
